import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { transcriptionApi } from '../../utils/api'

/**
 * 書き起こし一覧の取得（単一ページ）。
 * queryKey: ['transcriptions', { page, limit }]
 */
export function useTranscriptions(page = 1, limit = 20) {
  return useQuery({
    queryKey: ['transcriptions', { page, limit }],
    queryFn: () => transcriptionApi.list(page, limit),
  })
}

/**
 * 書き起こし一覧の追加読み込み（DashboardPage の「もっと見る」）。
 * 1ページ目だけを出すと 21 件目以降が画面から辿れなくなるため、ページを積み増して表示する。
 *
 * queryKey は ['transcriptions', ...] 始まりに揃える。アップロード完了後の
 * invalidateQueries({ queryKey: ['transcriptions'] }) が前方一致でこのキャッシュも無効化するため、
 * 新規書き起こしが履歴へ反映される。
 */
export function useInfiniteTranscriptions(limit = 20) {
  return useInfiniteQuery({
    queryKey: ['transcriptions', 'infinite', { limit }],
    queryFn: ({ pageParam }) => transcriptionApi.list(pageParam, limit),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      // 空ページが返ったら打ち切る。total だけを見ていると、件数の不整合時に
      // 進まない「もっと見る」を出し続けてしまう。
      if (lastPage.transcriptions.length === 0) return undefined
      // 取得済み件数が総件数に達したら次ページなし（undefined で hasNextPage=false）
      const loaded = allPages.reduce((sum, p) => sum + p.transcriptions.length, 0)
      return loaded < lastPage.total ? allPages.length + 1 : undefined
    },
  })
}
